import { createNode } from '@glueapp/graph-types';

export const EqualText = createNode({
    id: 'Equal Text',
    name: 'Equal Text',
    description: 'A block for checking if the two texts are the same.',
    aiDescription:
        'Compares two strings for exact equality. Connect strings to "Text1" and "Text2"; outputs a boolean on "Result". Note: findableInLibrary is false, so prefer other comparison approaches if available.',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    findableInLibrary: false,
    inPorts: {
        Text1: {
            kind: 'string',
        },
        Text2: {
            kind: 'string',
        },
    },
    outPorts: {
        Result: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        return { output: { Result: input.inPorts.Text1 === input.inPorts.Text2 } };
    },
});
